import { useEffect } from 'react';

import type { NWTEvent } from '@xing-com/crate-communication-tracking';
import { useTracking } from '@xing-com/crate-communication-tracking';

export const usePeopleDirectoryPageView = (key?: string): void => {
  const { track } = useTracking();
  const { track: trackNwt } = useTracking<NWTEvent>();
  useEffect(() => {
    track({
      type: 'pageview',
      channel: 'wbm/People_Directory',
      page: `wbm/People_Directory/${key}`,
    });
    trackNwt({
      application: 'wbm',
      type: 'nwt',
      event: 'viewed_screen',
      eventSchema: 'basic',
      channel: 'web',
      sentBy: 'people_directory',
      page: `people_directory/${key}`,
    });
  }, [key, track, trackNwt]);
};
